import { render } from "./WarrantyContainer.vue?vue&type=template&id=770c2ee0"
import script from "./WarrantyContainer.vue?vue&type=script&lang=js"
export * from "./WarrantyContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__